import React from "react";

export function Footer() {
  return <footer className="chroma-footer">v1.0.1</footer>;
}
